export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';

export const API_FAILURE = 'API_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const FETCH_CUSTOMER = 'FETCH_CUSTOMER';
export const FETCH_CUSTOMER_FAILURE = 'FETCH_CUSTOMER_FAILURE';
export const FETCH_PAYMENT_METHODS = 'FETCH_PAYMENT_METHODS';

export const PROFILE_UPDATE = 'PROFILE_UPDATE';

export const CHANGE_CARD = 'CHANGE_CARD';
export const CHANGE_PAYMENT_METHOD_SUCCESS = 'CHANGE_PAYMENT_METHOD_SUCCESSFULL';
export const ADD_NEW_PAYMENT_METHOD_SUCCESS = 'ADD_NEW_PAYMENT_METHOD_SUCCESS';
export const CHANGE_PAYMENT_METHOD = 'CHANGE_PAYMENT_METHOD';
export const ADD_PAYMENT_METHOD = 'ADD_PAYMENT_METHOD';

export const MAKE_LOAN_PAYMENT_LOAD = 'MAKE_LOAN_PAYMENT_LOAD';

export const PAY_NOW_BUTTON_CLICK = 'PAY_NOW_BUTTON_CLICK';
export const MAKE_PAYMENT_LOAD = 'MAKE_PAYMENT_LOAD';
export const GO_BACK_TO_MAKE_PAYMENT = 'GO_BACK_TO_MAKE_PAYMENT';

export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const SUBMITTING_PAYMENT = 'SUBMITTING_PAYMENT';

/** Plans related */
export const FETCH_PLANS_BEGIN = "FETCH_PLANS_BEGIN";
export const FETCH_PLANS_SUCCESS = "FETCH_PLANS_SUCCESS";
export const FETCH_PLANS_FALIURE = "FETCH_PLANS_FALIURE";

/** Plans related */
export const FETCH_LOANS_BEGIN = "FETCH_LOANS_BEGIN";
export const FETCH_LOANS_SUCCESS = "FETCH_LOANS_SUCCESS";
export const FETCH_LOANS_FAILURE = "FETCH_LOANS_FAILURE";

/** Transaction related */
export const FETCH_TRANSACTION_BEGIN = "FETCH_TRANSACTION_BEGIN";
export const FETCH_TRANSACTION_SUCCESS = "FETCH_TRANSACTION_SUCCESS";
export const FETCH_TRANSACTION_FAILURE = "FETCH_TRANSACTION_FALIURE";

/** Notification related */
export const FETCH_NOTIFICATION_BEGIN = "FETCH_NOTIFICATION_BEGIN";
export const FETCH_NOTIFICATION_SUCCESS = "FETCH_NOTIFICATION_SUCCESS";
export const FETCH_NOTIFICATION_FAILURE = "FETCH_NOTIFICATION_FAILURE";
/** Init Data  */
export const INIT_DATA_READY = "INIT_DATA_READY";

/** Customer Enquiry */
export const CUSTOMER_ENQUIRY_SENT = 'CUSTOMER_ENQUIRY_SENT';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_COMPLETED = 'RESET_PASSWORD_COMPLETED';

/** Statement related */

export const FETCH_STATEMENT_SUCCESS_FLAG_OFF = "FETCH_STATEMENT_SUCCESS_FLAG_OFF";

export const FETCH_LOAN_STATEMENT_BEGIN = "FETCH_LOAN_STATEMENT_BEGIN";
export const FETCH_LOAN_STATEMENT_SUCCESS = "FETCH_LOAN_STATEMENT_SUCCESS";
export const FETCH_LOAN_STATEMENT_FAILURE = "FETCH_LOAN_STATEMENT_FAILURE";

/** Loan related */
export const CLEAR_SELECTED_LOAN = "CLEAR_SELECTED_LOAN";
export const SET_SELECTED_LOAN = "SET_SELECTED_LOAN";

/** Remediation related */
export const REMEDIATION_BANK_ACCOUNT_UPDATE_SUCCESS = "REMEDIATION_BANK_ACCOUNT_UPDATE_SUCCESS";